<app-loader></app-loader>
<ng-container *ngIf="isAutorized(); else notAuthorized">
    <section class="w-100" id="main-section" [ngClass]="{'newui':switchEnabled}">
        <app-side-nav-outer-toolbar title="{{appInfo.title}}">
            <!--  <main [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''"> -->
            <router-outlet #o="outlet"></router-outlet>
            <!-- </main> -->
        </app-side-nav-outer-toolbar>
    </section>
</ng-container>
<ng-template #notAuthorized>
    <app-single-card>
        <!-- <main [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''"> -->
        <router-outlet #o="outlet"></router-outlet>
        <router-outlet name="public"></router-outlet>
    </app-single-card>
</ng-template>